export const API_HEADER = 'https://gbataxi.com/api';
// export const API_HEADER = 'https://gbataxi.com/api';

export enum GBACity {
  HONG_KONG = "香港",
  SHENZHEN = "深圳",
  ZHONGSHAN = "中山",
  GUANGZHOU = "广州",
  DONGGUAN = "东莞",
  MACAU = "澳门",
  ZHUHAI = "珠海",
  FOSHAN = "佛山",
  JIANGMEN = "江门",
  HUIZHOU = "惠州",
  ZHAOQING = "肇庆"
}

export enum CountryCode {
  HONG_KONG = "852",
  MAINLAND_CHINA = "86",
  MACAU = "853",
}

// export enum AuthMode {
//   LOGIN = "login",
//   REGISTER = "register",
// }

export enum Gender {
  MALE = 'M',
  FEMALE = 'F',
}

// Navigation Configuration
export const NAV_ITEMS = [
{ label: "About", route: "/" },
  { label: "Book a Ride", route: "/book" },
  { label: "Passenger", route: "/passenger" },
  { label: "Driver", route: "/driver" },
  { label: "Cross-border Travel", route: "/cross-border" },
  { label: "Shared Ride", route: "/shared-ride" },
  { label: "App", route: null } // Updated to null since this button does not navigate
];

export const MOBILE_NAV_ITEMS = [
  { label: "about", route: "/aboutus" },
  { label: "latestNews", route: "/latest_news" },
  { label: "careerTraining", route: "/career_training" },
  // ... other mobile nav items
];

export const FOOTER_LINKS = {
  GBA_TAXI: [
    { label: 'Home', path: '#' },
    { label: 'About', path: '#' },
    { label: 'Drivers Recruitment', path: '#' },
    { label: 'News Center', path: '#' }
  ],
  TRAVEL_SERVICES: [
    { label: 'Cross-border Ride-hailing', path: '#' },
    { label: 'Shared Ride-hailing', path: '#' },
    { label: 'Local Ride-hailing Taxi', path: '#' }
  ],
  CONTACT_US: [
    { label: 'Email', path: '#' },
    { label: 'WhatsApp', path: '#' },
    { label: 'Linkedin', path: '#' },
    { label: 'Address', path: '#' }
  ],
  INFORMATION: [
    { label: 'FAQ', path: '#' },
    { label: 'All Documents', path: '#' }
  ]
};

export const allStatuses = [
  'WAITING_CONFIRM',
  'DRIVER_CONFIRM',
  'DRIVER_ON_THE_WAY',
  'DRIVER_ARRIVED',
  'PASSENGER_PICKED_UP',
  'TRAVEL_PROGRESSING',
  'DESTINATION_ARRIVAL',
  'FINISHED'
];
